<div class="date-widget__body">
  <span class="text-[52px] leading-[30px] font-normal mb-[15px]"
        data-test-id="appointment-date-day-number">{{ date | date : 'd' }}</span>
  <span class="text-[42px] leading-[30px] font-normal"
        data-test-id="appointment-date-month">{{ date | localizedDate : 'MMMM' }}</span>
</div>
<div class="date-widget__footer">
    <span data-test-id="appointment-date-day">{{ date | localizedDate : 'EEEE' }}</span>
    <span data-test-id="appointment-date-time">{{ date | date : 'HH:mm' }}</span>
</div>
